import React from "react";
import { Crown } from "lucide-react";

export function AlphaDenBadge({ className = "", compact = false }) {
  return (
    <span data-testid="alpha-den-badge" title="The Alpha's Den"
      className={`shrink-0 inline-flex items-center gap-0.5 text-[10px] font-semibold text-amber-300 border border-amber-500/40 bg-amber-500/10 rounded-full px-1.5 py-0.5 ${className}`}>
      <Crown className="w-2.5 h-2.5" />{!compact && " Alpha"}
    </span>
  );
}
